import { SearchItemOperator } from '@Types/api/common/filters';
import { Mapper } from '@Features/utils/prepareSearchCriterias';
import { CompanyDict, TypeDict } from '@Types/index';

import { FilterForm } from './types';

export const initialValuesFilterForm: FilterForm = {
  empNumber: '',
  companies: [],
  requestTypes: [],
  createdDateFrom: '',
  createdDateTo: '',
};

export const filterTypes: Record<string, SearchItemOperator> = {
  empNumber: 'like',
  requestTypes: 'in',
  companies: 'in',
  createdDateFrom: 'ge',
  createdDateTo: 'le',
};

export const getFiltersMapper =
  (companies: CompanyDict[], requestTypes: TypeDict[]): Mapper =>
  (key, value) => {
    if (key === 'empNumber') {
      return ['employeeNumber', `%${value}%`];
    }

    if (key === 'companies') {
      const resultValue = (value as string[]).map(
        (item) =>
          companies.find((company) => company.compCode === item)!.compName
      );
      return ['companyName', resultValue];
    }

    if (key === 'requestTypes') {
      const resultValue = (value as string[]).map(
        (item) =>
          requestTypes.find((requestType) => requestType.codeDesc === item)!
            .codeNum
      );
      return ['requestTypeId', resultValue];
    }

    if (key === 'createdDateFrom') {
      return ['created', value];
    }

    if (key === 'createdDateTo') {
      return ['created', value];
    }

    return ['', value];
  };
